import { Typography } from '@mui/material';

const ItineraryTitle = ({ children, sx = {}, ...props }) => {
  return (
    <Typography
      sx={{
        fontFamily: 'Open Sans, sans-serif',
        fontWeight: 600,
        fontSize: { xs: '14px', sm: '16px', lg: '14px' },
        color: '#000',
        lineHeight: 1.2,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
};

export default ItineraryTitle;
